import {createContext} from "react";

export const MyToastContext = createContext("");